

































import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import SearchBar from "@/components/SearchBar.vue";
@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  @Provide("$api") $api: any;
  private drawer = false;

  created() {
    this.$store.commit("startLoading");
    this.$store.state.allCategories = [];
    this.$api.get("api/categories/").then((result: any) => {
      this.$store.state.allCategories = result.data;
      this.$store.commit("stopLoading");
    });
  }

  get categories() {
    return this.$store.state.allCategories;
  }

  openDrawer() {
    this.drawer = true;
  }
}
